import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "label", {}, () => [
      (_ctx.label && !_ctx.noLabel)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _ctx.labelFor,
            class: _normalizeClass([
          _ctx.extraLabelClasses,
          { 'sr-only': _ctx.$slots.label },
          _ctx.labelsClasses
        ])
          }, _toDisplayString(_ctx.label), 11, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.$slots.default)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "message", {}, () => [
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass([_ctx.messageClasses])
          }, _toDisplayString(_ctx.message), 3))
        : _createCommentVNode("", true)
    ])
  ]))
}